(function () {
  const KEY = 'aur_wishlist_v1';
  const normalize = (h) => (typeof h === 'string' ? h.trim().toLowerCase() : '');

  // Read + clean
  const getList = () => {
    try {
      const raw = JSON.parse(localStorage.getItem(KEY) || '[]');
      const cleaned = Array.from(
        new Set((Array.isArray(raw) ? raw : []).map(normalize).filter(Boolean))
      );
      if (JSON.stringify(raw) !== JSON.stringify(cleaned)) {
        localStorage.setItem(KEY, JSON.stringify(cleaned));
      }
      return cleaned;
    } catch {
      return [];
    }
  };

  // Write + clean
  const setList = (arr) => {
    const cleaned = Array.from(new Set((arr || []).map(normalize).filter(Boolean)));
    localStorage.setItem(KEY, JSON.stringify(cleaned));
    return cleaned;
  };

  const inWishlist = (handle) => getList().includes(normalize(handle));

  // Header badge updater (reuses Dawn's .cart-count-bubble)
  function updateHeaderBadge() {
    const root = document.getElementById('wishlist-icon-bubble');
    if (!root) return;
    const bubble = root.querySelector('.cart-count-bubble');
    if (!bubble) return;

    if (!window.__isLoggedIn) {
    bubble.hidden = true;
    return;
  }


    const n = getList().length;

    // Always write the number (prevents stale “1”)
    const numEl = bubble.querySelector('span[aria-hidden="true"]');
    if (numEl) numEl.textContent = n > 99 ? '99+' : String(n);

    const sr = bubble.querySelector('.visually-hidden');
    if (sr) sr.textContent = `${n} items in wishlist`;

    bubble.hidden = (n === 0); // hide when 0 (show “0”? set to false instead)
  }

  // Toggle add/remove and reflect state
  function toggle(handle) {
    const h = normalize(handle);
    const list = getList();
    const i = list.indexOf(h);
    if (i > -1) list.splice(i, 1);
    else list.push(h);

    // Save, then re-read as source of truth (fixes 1→0 edge-case)
    setList(list);
    const finalList = getList();

    // Update all buttons
    document.querySelectorAll('[data-wishlist-handle]').forEach((btn) => {
      const bh = normalize(btn.getAttribute('data-wishlist-handle'));
      const active = finalList.includes(bh);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    updateHeaderBadge();
    document.dispatchEvent(new CustomEvent('wishlist:changed', { detail: { list: finalList } }));
  }

  // Bind buttons (guards against double-binding)
  function bindAll(root = document) {
    root.querySelectorAll('.wishlist-toggle').forEach((btn) => {
      if (btn.dataset.wlBound === '1') return;
      btn.dataset.wlBound = '1';

      const handle = btn.getAttribute('data-wishlist-handle');
      const logged = !!window.__isLoggedIn;
      const active = logged && inWishlist(handle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');


      // btn.addEventListener('click', () => toggle(handle));
      btn.addEventListener('click', () => {
  if (!window.__isLoggedIn) {
    if (window.AIAuthModal && typeof window.AIAuthModal.open === 'function') {
      window.AIAuthModal.open();
    } else {
      window.location.href = '/account/login?return_url=' + encodeURIComponent(window.location.pathname + window.location.search);
    }
    return;
  }
  toggle(handle);
});

    });
  }

  // Public API (optional)
  window.AurumWishlist = { getList, inWishlist, toggle, bindAll, updateHeaderBadge };

  // Init + keep in sync
  document.addEventListener('DOMContentLoaded', () => {
    bindAll();
    updateHeaderBadge();
  });
  document.addEventListener('wishlist:changed', updateHeaderBadge);
  window.addEventListener('storage', (e) => {
    if (e.key === KEY) updateHeaderBadge();
  });
})();